var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgActivityCreateRoll = function SvgActivityCreateRoll(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19.33 21.21"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#4ea5b5}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.58 0C2 0 0 .85 0 1.6s2 1.6 4.58 1.6 4.58-.85 4.58-1.6S7.2 0 4.58 0Zm0 2.17C3.65 2.17 3 1.87 3 1.6S3.65 1 4.58 1s1.61.3 1.61.57-.69.6-1.61.6Z",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 3.12v16c0 1.16 2 2.1 4.58 2.1s4.58-.94 4.58-2.1v-16a9.67 9.67 0 0 1-4.58 1 9.67 9.67 0 0 1-4.58-1ZM10.2 2.98h9.14v16.31H10.2z",
    className: "cls-1"
  })))));
};
export default SvgActivityCreateRoll;